exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pay-in-modal .checkbox-component label {\n  font-family: 'Open Sans Regular', Helvetica, Arial, sans-serif !important;\n  font-weight: normal !important;\n}\n.pay-in-modal .pay-in__create-btn:not(:disabled):hover,\n.pay-in-modal .pay-in__create-btn:not(:disabled):active {\n  background-color: #6ac951 !important;\n  border-color: rgba(75, 83, 107, 0.35) !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-16ab3ee0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationPayIn/Step2PartialItems.vue
// module id = 2012
// module chunks = 0